import { FloatLabelDesignTokens } from '@primeuix/themes/types/floatlabel';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import { tDeep, tNum } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/floatlabel/index.ts
const fl = tDeep(componentCommon.floatlabel);

export const FloatLabelTelekomDT: FloatLabelDesignTokens = {
  root: {
    color: fl.color,
    focusColor: fl.focus.color,
    activeColor: fl.active.color,
    invalidColor: fl.invalid.color,
    positionX: fl.position.x,
    positionY: fl.position.y,
    fontWeight: tNum(componentCommon.floatlabel.font.weight),
    active: {
      fontSize: fl.active.font.size,
      fontWeight: tNum(componentCommon.floatlabel.active.font.weight),
    },
  },
  over: {
    active: {
      top: fl.over.active.top,
    },
  },
  in: {
    input: {
      paddingTop: fl.in.input.padding.top,
      paddingBottom: fl.in.input.padding.bottom,
    },
    active: {
      top: fl.in.active.top,
    },
  },
  on: {
    borderRadius: fl.on.border.radius,
    active: {
      background: fl.on.active.background,
      padding: `${fl.on.active.padding.y} ${fl.on.active.padding.x}`,
    },
  },
};
